// import { Box, Button, Checkbox, Link } from "@mui/material";
import { useState } from "react";
// import ErrorHelper from "../../../../../components/ErrorWrapper";
// import Flex from "../../../../../components/Flex";
// import LoadingOverlay from "../../../../../components/LoadingOverlay";
// import StyledDialog from "../../../../../components/StyledDialog";
import { useSignatureController } from "../../../../../components/signiture/use-signature-controller";
// import { useCreateDocument } from "../../../../../hooks/use-create-document";
import useDisclosure from "../../../../../hooks/use-disclosure";
import PhysicianPatientArbitrationAgreementForm from "./PhysicianPatientArbitrationAgreementForm";

export const PhysicianPatientArbitrationAgreementButton = ({
  setFieldValue,
  values,
  viewOnly,
  // errors,
}: {
  setFieldValue: (field: string, value: any) => void;
  values: any;
  viewOnly?: boolean;
  errors: any;
}) => {
  const disclosureHost = useDisclosure();
  const [_k, setK] = useState<boolean>(true);
  const { canvasRef, signPad, isSignEmpty } = useSignatureController(
    disclosureHost.opened,
    values.physicianPatientArbitrationAgreementSign
  );
  // const [isLoading, setIsLoading] = useState(false);
  // const { createDocumentWithHtml, eleRef } = useCreateDocument(setIsLoading);

  // const renderContent = () => {
  //   return (
  //     <Box width={"40vw"} overflow={"hidden"}>
  //       <Box ref={eleRef}>
  //         <PhysicianPatientArbitrationAgreementForm
  //           viewOnly={isPreviewVisible || viewOnly}
  //           canvasRef={canvasRef}
  //           signPad={signPad}
  //           setK={setK}
  //           setFieldValue={setFieldValue}
  //           values={values}
  //         />
  //       </Box>
  //     </Box>
  //   );
  // };

  return (
    <>
      {/* <LoadingOverlay isLoading={isLoading} /> */}
      {/* {!isPreviewVisible && (
        <ErrorHelper error={errors.physicianPatientArbitrationAgreement}>
          <Flex gap={1} alignItems={"center"}>
            <Checkbox
              disabled={viewOnly}
              checked={values.physicianPatientArbitrationAgreement}
              onChange={(_, checked) =>
                setFieldValue("physicianPatientArbitrationAgreement", checked)
              }
            />
            <span>
              I agree to the <b>Physician Patient Arbitration Agreement</b>{" "}
              &nbsp;
              <Link href="#" onClick={() => disclosureHost.open()}>
                terms & conditions.
              </Link>
            </span>
          </Flex>
        </ErrorHelper>
      )} */}

      {/* {!isPreviewVisible ? ( */}
      {/* <StyledDialog
          open={disclosureHost.opened}
          onClose={disclosureHost.close}
          dialogTitle="Physician Patient Arbitration Agreement"
          dialogAction={
            !viewOnly ? (
              <Button
                variant="contained"
                onClick={() => {
                  setFieldValue(
                    "physicianPatientArbitrationAgreementSign",
                    isSignEmpty() ? undefined : signPad?.toDataURL()
                  );

                  createDocumentWithHtml(
                    "Physician_Patient_Arbitration_Agreement.pdf"
                  ).then(() => {
                    disclosureHost.close();
                  });
                }}
              >
                Submit
              </Button>
            ) : (
              ""
            )
          }
        >
          {renderContent()}
        </StyledDialog>
      ) : (
        renderContent()
      )} */}
      <PhysicianPatientArbitrationAgreementForm
        viewOnly={viewOnly}
        canvasRef={canvasRef}
        signPad={signPad}
        setK={setK}
        setFieldValue={setFieldValue}
        values={values}
        isSignEmpty={isSignEmpty}
      />
    </>
  );
};
